import tw from "twin.macro";
import styled from "styled-components";
import { schemeDetails, schemeStatus } from "api/NewSchemeApi";
import { branchdetails } from "api/BranchDetailsApi";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg/svg-decorator-blob-5.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "images/svg/svg-decorator-blob-7.svg";
import Noimg from "../images/no_img.jpg";
import { getBranchId, getCustomerId } from "../utility/HeaderConfig.js";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { dataList } from "api/SkeletonData";
import Skeleton from "react-loading-skeleton";
import { useCartContext } from "context/UseCartContext";

const Container = tw.div`relative font-display overflow-hidden`;
const DecoratorBlob1 = styled(SvgDecoratorBlob1)`${tw`pointer-events-none -z-20 absolute right-0 top-0 h-64 w-64 opacity-15 transform translate-x-2/3 -translate-y-12 text-pink-400`}`;
const DecoratorBlob2 = styled(SvgDecoratorBlob2)`${tw`pointer-events-none -z-20 absolute left-0 bottom-0 h-80 w-80 opacity-15 transform -translate-x-2/3 text-custom-100`}`;

const STAT_STYLE = {
  display: "flex", justifyContent: "space-between", alignItems: "center",
  padding: "10px 16px", borderBottom: "1px solid #f0eaf8",
};

export default ({ configImages }) => {
  const [SchemeDetails, setSchemeDetails] = useState([]);
  const [showModal, setshowModal] = useState(false);
  const [BranchMobile, setBranchMobile] = useState("");
  const [loading, setLoading] = useState(true);
  const [isReadMore, setIsReadMore] = useState(false);
  const history = useNavigate();
  const { dispatch } = useCartContext();
  const location = useLocation();
  const myparam = location.state;

  useEffect(() => { getSchemeDetail(); }, []); // eslint-disable-line

  const getSchemeDetail = () => {
    setLoading(true);
    schemeDetails(myparam.item).then(
      (data) => { setSchemeDetails(data.response.content); setLoading(false); },
      (err) => console.log(err)
    );
  };

  const schemeCheck = (itemName, item) => {
    let requestName = itemName.toLowerCase() === "digigold" || itemName.toLowerCase() === "digisilver" ? "Active" : "Waiting_For_Approval";
    if (getCustomerId() === undefined) {
      dispatch({ type: "MODAL", payload: "login" });
    } else {
      if (getCustomerId() && getCustomerId() !== null && getCustomerId() !== "onlinepayment") {
        schemeStatus({ customerEntity: getCustomerId(), chitEnrollStatus: requestName }).then((data) => {
          const show = data.response.content.filter((item) => item.metaChitName === itemName);
          if (show.length > 0) { setshowModal(true); getbranchdetails(); }
          else history("/JoinScheme", { state: { item } });
        });
      }
    }
  };

  const getbranchdetails = () => {
    branchdetails(getBranchId()).then((data) => setBranchMobile(data.response.mobile));
  };

  return (
    <Container>
      <section style={{ padding: "48px 0 64px", background: "linear-gradient(160deg,#faf7ff 0%,#f0e9ff 100%)", minHeight: "60vh" }}>
        <div className="container">
          {/* Page heading */}
          <div style={{ textAlign: "center", marginBottom: 40 }}>
            <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".16em", textTransform: "uppercase", color: "#7517b4", margin: "0 0 8px" }}>
              Saving Schemes
            </p>
            <h2 style={{ fontFamily: "Cormorant Garamond,Georgia,serif", fontSize: "clamp(26px,4vw,36px)", fontWeight: 600, color: "#2d1752", margin: "0 0 10px" }}>
              Choose Your Scheme
            </h2>
          </div>

          {/* Loading skeletons */}
          {loading && (
            <div className="row g-4">
              {dataList.slice(0, 6).map((_, i) => (
                <div key={i} className="col-md-6 col-xl-4">
                  <div style={{ borderRadius: 20, overflow: "hidden", background: "#fff", boxShadow: "0 4px 20px rgba(0,0,0,.06)" }}>
                    <Skeleton style={{ height: 220 }} />
                    <div style={{ padding: 20 }}>
                      <Skeleton height={18} style={{ marginBottom: 10, borderRadius: 6 }} />
                      <Skeleton height={12} count={3} style={{ marginBottom: 6, borderRadius: 4 }} />
                      <Skeleton height={44} style={{ borderRadius: 10, marginTop: 16 }} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Scheme cards */}
          {!loading && (
            <div className="row g-4">
              {SchemeDetails.map((item) => (
                <div key={item.id} className="col-md-6 col-xl-4">
                  <div style={{
                    borderRadius: 20, overflow: "hidden", background: "#fff",
                    boxShadow: "0 4px 24px rgba(79,50,103,.1)",
                    transition: "box-shadow .24s, transform .24s",
                    height: "100%", display: "flex", flexDirection: "column",
                  }}
                    onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 16px 48px rgba(79,50,103,.18)"; e.currentTarget.style.transform = "translateY(-5px)"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "0 4px 24px rgba(79,50,103,.1)"; e.currentTarget.style.transform = "none"; }}
                  >
                    {/* Image */}
                    <div style={{ overflow: "hidden", background: "#f5f0ff", position: "relative" }}>
                      <img
                        src={item.chitImage && item.chitImage !== "" && item.chitImage !== "-" && item.chitImage !== "Image_Not_Available" ? item.chitImage : Noimg}
                        alt="schemeImage"
                        style={{ width: "100%", height: 220, objectFit: "cover", display: "block", transition: "transform .4s" }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "none"}
                      />
                      {/* Type badge */}
                      <span style={{
                        position: "absolute", top: 12, left: 12,
                        background: "rgba(79,50,103,.85)", color: "#fff", backdropFilter: "blur(4px)",
                        padding: "4px 12px", borderRadius: 999, fontSize: 11, fontWeight: 700, letterSpacing: ".06em", textTransform: "uppercase",
                      }}>{item.chitType}</span>
                    </div>

                    {/* Body */}
                    <div style={{ padding: "20px 22px", flex: 1, display: "flex", flexDirection: "column" }}>
                      <h5 style={{ fontFamily: "Cormorant Garamond,Georgia,serif", fontSize: 20, fontWeight: 700, color: "#2d1752", margin: "0 0 14px", textAlign: "center", letterSpacing: ".01em" }}>
                        {item.chitTypeName}
                      </h5>

                      {/* Stats */}
                      <div style={{ background: "#faf5ff", borderRadius: 12, border: "1px solid #ede3ff", marginBottom: 14, overflow: "hidden" }}>
                        <div style={STAT_STYLE}>
                          <span style={{ fontSize: 12, color: "#6c6c70", fontWeight: 500 }}>Group Code</span>
                          <span style={{ fontSize: 13, color: "#2d1752", fontWeight: 700 }}>{item.name}</span>
                        </div>
                        <div style={STAT_STYLE}>
                          <span style={{ fontSize: 12, color: "#6c6c70", fontWeight: 500 }}>Due Amount</span>
                          <span style={{ fontSize: 13, color: "#7517b4", fontWeight: 700 }}>₹ {item.chitAmount}</span>
                        </div>
                        <div style={STAT_STYLE}>
                          <span style={{ fontSize: 12, color: "#6c6c70", fontWeight: 500 }}>Duration</span>
                          <span style={{ fontSize: 13, color: "#2d1752", fontWeight: 700 }}>{item.noOfMonths} {item.duration === "MONTH" ? "Months" : "Days"}</span>
                        </div>
                        <div style={{ ...STAT_STYLE, borderBottom: "none" }}>
                          <span style={{ fontSize: 12, color: "#6c6c70", fontWeight: 500 }}>Maturity Amount</span>
                          <span style={{ fontSize: 13, color: "#2d1752", fontWeight: 700 }}>{item.maturityAmount > 0 ? `₹ ${item.maturityAmount}` : "—"}</span>
                        </div>
                      </div>

                      {/* Description */}
                      {item.description !== "" && (
                        <div style={{ flex: 1, marginBottom: 14 }}>
                          <p style={{ fontSize: 12.5, lineHeight: 1.7, color: "#48484a", margin: 0 }}>
                            {isReadMore === item.id ? item.description : item.description.slice(0, 120)}
                            {item.description.length > 120 && (
                              <button onClick={() => setIsReadMore(isReadMore === item.id ? false : item.id)}
                                style={{ background: "none", border: "none", padding: 0, marginLeft: 4, fontSize: 12, fontWeight: 700, color: "#7517b4", cursor: "pointer" }}>
                                {isReadMore === item.id ? " Show less" : " Read more"}
                              </button>
                            )}
                          </p>
                        </div>
                      )}

                      {/* CTA */}
                      <button
                        onClick={() => schemeCheck(item.name, item)}
                        style={{
                          display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                          padding: "13px 20px", background: "linear-gradient(135deg,#4f3267,#7517b4)",
                          color: "#fff", fontSize: 13, fontWeight: 700, letterSpacing: ".06em", textTransform: "uppercase",
                          border: "none", borderRadius: 10, cursor: "pointer", width: "100%",
                          transition: "opacity .14s, transform .14s", boxShadow: "0 4px 16px rgba(79,50,103,.3)",
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.opacity = ".88"; e.currentTarget.style.transform = "translateY(-1px)"; }}
                        onMouseLeave={(e) => { e.currentTarget.style.opacity = "1"; e.currentTarget.style.transform = "none"; }}
                      >
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                          <path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/>
                        </svg>
                        Join Scheme
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        <DecoratorBlob1 /><DecoratorBlob2 />
      </section>

      {/* Already joined modal */}
      {showModal && (
        <>
          <motion.div
            initial={{ opacity: 0, scale: 0.92, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            style={{ position: "fixed", inset: 0, zIndex: 50, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
          >
            <div style={{ background: "#fff", borderRadius: 20, boxShadow: "0 24px 80px rgba(0,0,0,.18)", width: "100%", maxWidth: 400, overflow: "hidden" }}>
              {/* Header */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 20px", borderBottom: "1px solid #f0e9fa" }}>
                <h6 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: "#2d1752", textTransform: "uppercase", letterSpacing: ".06em" }}>Join Scheme</h6>
                <button onClick={() => setshowModal(false)} style={{ background: "none", border: "none", cursor: "pointer", color: "#6c6c70", fontSize: 20, lineHeight: 1 }}>
                  <i className="bi bi-x-circle"></i>
                </button>
              </div>
              {/* Body */}
              <div style={{ padding: "28px 24px", textAlign: "center" }}>
                <div style={{ width: 56, height: 56, borderRadius: "50%", background: "#fff3cd", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2">
                    <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
                  </svg>
                </div>
                <p style={{ fontSize: 14, color: "#48484a", marginBottom: 8 }}>Already joined — status is <strong>Pending</strong></p>
                <p style={{ fontSize: 13, color: "#6c6c70", marginBottom: 6 }}>Please contact customer support</p>
                <strong style={{ fontSize: 15, color: "#2d1752" }}>{BranchMobile}</strong>
              </div>
              <div style={{ padding: "0 24px 24px" }}>
                <button onClick={() => setshowModal(false)}
                  style={{ width: "100%", padding: "12px", background: "#4f3267", color: "#fff", border: "none", borderRadius: 10, fontWeight: 700, fontSize: 13, cursor: "pointer", letterSpacing: ".05em" }}>
                  Got it
                </button>
              </div>
            </div>
          </motion.div>
          <div style={{ opacity: 0.4, position: "fixed", inset: 0, zIndex: 40, background: "#000" }}></div>
        </>
      )}
    </Container>
  );
};